<template>
  <div>
    <el-dialog
      :visible.sync="dialogShow"
      :width="`${width}px`"
      :close-on-click-modal="false"
      @close="closeDialog"
      append-to-body
      class="tipConfirmDialogContent dialogBoxFormat"
      destroy-on-close
    >
      <div slot="title">
        {{ title }}
      </div>
      <slot></slot>
      <div class="btnFormat new_warehouse" v-if="showFooter" slot="footer">
        <el-button
          plain
          :loading="btnLoading"
          style="min-width: 65px; height: 32px; font-size: 14px"
          size="mini"
          @click="closeDialog"
          >取消</el-button
        >
        <el-button
          style="min-width: 65px; height: 32px; font-size: 14px"
          :loading="btnLoading"
          type="primary"
          size="mini"
          @click="confirm"
          >{{ confirmLabel }}</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "ConfirmDialog",
  components: {},
  props: {
    dialogShow: {
      default: false,
    },
    title: {
      default: "",
    },
    confirmLabel: {
      default: "确定",
    },
    width: {
      default: 800,
    },
    btnLoading: {
      default: false,
    },
    showFooter: {
      default: true,
    },
  },
  data() {
    return {};
  },
  computed: {},
  methods: {
    closeDialog() {
      this.$emit("updateDialogShow", false);
    },
    confirm() {
      this.$emit("confirm");
    },
  },
  created() {},
  mounted() {},
  destroyed() {},
};
</script>

<style scoped lang="scss">
</style>
